import { Paper, Typography, Stack, Chip } from "@mui/material";
import styles from "../../styles/proposal/projectDetail.module.css";
import InsertLinkIcon from "@mui/icons-material/InsertLink";

type ProjectDetailProps = {
  projectDetail: any;
};

const ProjectDetail = (props: ProjectDetailProps) => {
  const projectDetail = props.projectDetail;

  return (
    <Paper elevation={4} className={styles.paper} sx={{ borderRadius: "10px" }}>
      <Typography variant="h5"> Project Details</Typography>

      {projectDetail.project_status_description && (
        <Stack direction="row" className={styles.stack}>
          <Typography variant="body1">Project Status: </Typography>
          <Chip
            label={projectDetail.project_status_description}
            size="small"
            color="info"
          />
        </Stack>
      )}

      {/* if "project_completed" false then only show "project_on_track" information */}

      {!projectDetail.project_completed && projectDetail.project_on_track && (
        <Stack direction="row" className={styles.stack}>
          <Typography variant="body1">Project on Track: </Typography>
          <Chip
            label={projectDetail.project_on_track ? "True" : "False"}
            size="small"
            color="primary"
          />
        </Stack>
      )}

      {/* if "project_completed" true show "completed_date" (if available) else show "expected_completion_date" (if available) */}
      {projectDetail.project_completed && projectDetail.completed_date && (
        <Stack direction="row" className={styles.stack}>
          <Typography variant="body1">
            {`Completion Date: ${projectDetail.completed_date}`}
          </Typography>
        </Stack>
      )}

      {projectDetail.project_completed &&
        !projectDetail.completed_date &&
        projectDetail.expected_completion_date && (
          <Stack direction="row" className={styles.stack}>
            <Typography variant="body1">
              {`Expected Completion Date: ${projectDetail.expected_completion_date}`}
            </Typography>
            {/* <Chip label={projectDetail.expected_completion_date} size="small" /> */}
          </Stack>
        )}

      {projectDetail.evidence && (
        <div className={styles.centerDiv}>
          <InsertLinkIcon className={styles.linkButton} />
          <a
            href={projectDetail.evidence}
            target="_blank"
            rel="noopener noreferrer"
          >
            {"Evidence"}
          </a>
        </div>
      )}

      {projectDetail.final_report && (
        <div className={styles.centerDiv}>
          <InsertLinkIcon className={styles.linkButton} />
          <a
            href={projectDetail.final_report}
            target="_blank"
            rel="noopener noreferrer"
          >
            {"Final Report"}
          </a>
        </div>
      )}

      {projectDetail.final_video && (
        <div className={styles.centerDiv}>
          <InsertLinkIcon className={styles.linkButton} />
          <a
            href={projectDetail.final_video}
            target="_blank"
            rel="noopener noreferrer"
          >
            {"Final Video"}
          </a>
        </div>
      )}

      <Typography variant="h6">
        {projectDetail.notes ? `Notes:\n` : "No Notes avaiable. "}
      </Typography>

      {projectDetail.notes && (
        <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
          {projectDetail.notes}
        </Typography>
      )}
    </Paper>
  );
};

export default ProjectDetail;
